import { useQuery } from '@tanstack/react-query'
import { queryClient } from '../queryClient'
import { retrieveCommunityFilterOptions } from './feed'

export const communityFiltersOptions = queryClient.queryKey<string[]>(['community-filter-options'])

export const useCommunityFilterOptions = () => {
  const options = useQuery({
    queryKey: communityFiltersOptions.key,
    refetchOnWindowFocus: false,
    queryFn: retrieveCommunityFilterOptions,
    refetchOnMount(q) {
      return q.state.dataUpdateCount == 0
    }
  })

  return options
}
